
import React, { Component } from 'react';
import { Modal, Form, Input, TreeSelect, Col, Row, Divider } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import validator from '../../../util/validator';
import orgUtil from '../../ui/orgUtil';
import Image from '../../ui/Image';
import Scanner from '../../ui/Scanner';

const fields = [{
    "text": "所属市场",
    "field": "orgCode",
    org: true,
    rules: [
        { required: true, message: '所属市场不能为空!' },
    ]
}, {
    "text": "会员名称",
    "field": "name",
    rules: [
        { required: true, message: '会员名称不能为空!' },
        { max: 32, message: '会员名不能超过32个字符！' },
    ]
}, {
    "text": "竞价会员编号",
    "field": "abbreviation",
    rules: [
        { max: 32, message: '竞价会员编号不能超过32个字符！' },
    ]
}, {
    "text": "证件号码",
    "field": "creditNo",
    rules: [
        { max: 32, message: '证件号码不能超过32个字符！' },
        validator.creditNo
    ]
}, {
    "text": "联系人证件号",
    "field": "contactManCreditNo",
    rules: [
        validator.creditNo
    ]
}, {
    "text": "地址",
    "field": "address",
    rules: [
        { max: 64, message: '地址不能超过64个字符！' },
    ]
}, {
    "text": "联系人",
    "field": "contactMan",
    rules: [
        { max: 16, message: '联系人不能超过64个字符！' },
    ]
}, {
    "text": "联系电话",
    "field": "contactNumber",
    rules: [
        validator.tel
    ]
}];


class AgentEditForm extends Component {

    state = {
        orgList: [],
        firstOrg: '',

        //其他额外照片
        visible: false, // 扫描仪
        otherImagesUrl: [],
        otherImage: [],
    }

    componentDidMount() {
        this.props.initEdit(this.initEdit);
        orgUtil.findOrg(
            { orgType: 4 },   //只查询市场会员的组织信息
            (res) => {
                let firstOrg = '';
                if (res != null && res.length > 0) {
                    firstOrg = res[0].code;
                }
                this.setState({ orgList: res, firstOrg: firstOrg });
            }
        );
    }

    initEdit = (data) =>{
        let otherImages = data.interContractImages;
        let otherImagesUrl = [];
        let otherImage = [];
        if (otherImages != null && otherImages.length > 0) {
            for (let index in otherImages) {
                if (otherImages[index] != null && otherImages[index] !== "") {
                    otherImage.push("data:image/jpeg;base64," + otherImages[index].replace(/\r\n/g, ""));
                }
            }
            otherImagesUrl = data.interContractImagesUrl;
        }
        this.setState({ otherImage: otherImage, otherImagesUrl: otherImagesUrl });
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let memberCode = this.props.editData.code
            if (memberCode !== undefined && memberCode != null) {
                values["code"] = memberCode;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            values["auction"] = 1;
            let other = [];
            let otherImage = this.state.otherImage;
            let otherImagesUrl = this.state.otherImagesUrl;
            for(let i=0; i< this.state.otherImage.length; i++){
                if(otherImagesUrl.length>i && otherImagesUrl[i] != null && otherImagesUrl[i] !== ""){
                    other.push(otherImagesUrl[i]);
                }else{
                    other.push(otherImage[i]);
                }
            }
            values["intermediaryContract"] = JSON.stringify(other);

            http.post({
                url: '/auctionMember/saveAuctionMember',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let orgCode = editData.orgCode;
        if (orgCode == null || orgCode === '') {
            orgCode = this.state.firstOrg;
        }
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: item.field === "orgCode" ? orgCode : editData[item.field],
                        })(
                            item.org ? <TreeSelect treeData={this.state.orgList} treeDefaultExpandAll={true} />
                                : <Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    createOtherImageDom = () => {
        let dom = [];
        let data = this.state.otherImage;
        let otherImagesUrl = this.state.otherImagesUrl;
        for (let i = 0; i <= data.length && i < 6; i++) {
            let file = data[i];
            let url = i < otherImagesUrl.length ? otherImagesUrl[i] : null;
            dom.push(
                <Col span={6} key={i} style={{ height: '112px' }}>
                    <Image
                        openScanner={this.showModal.bind(this, "otherImage")}
                        onChange={this.handleUploadImage.bind(this, "otherImage")}
                        onRemove={this.handleRemoveImage.bind(this, "otherImage", i)}
                        file={file}
                        text={''}
                        url={url}
                    />
                </Col>
            );
        }
        return dom;
    }

    handleUploadImage = (field, { base64 }) => {
        const list = this.state.otherImage;
        list.push(base64);
        this.setState({ "otherImage": list });
    }
    handleRemoveImage = (field, index) => {
        if (field === "otherImage") {
            const list = this.state.otherImage;
            const otherImagesUrl = this.state.otherImagesUrl;
            list.splice(index, 1);
            otherImagesUrl.splice(index, 1);
            this.setState({ "otherImage": list, "otherImagesUrl": otherImagesUrl });
        }
    }
    showModal = (field) => {
        this.setState({ visible: true, imageField: field });
        this.state.initScanner();
    };
    hiddenModal = () => {
        this.setState({ visible: false });
    };

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="商户信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    {this.createDom(fields)}
                    <Divider orientation="left">居间合同</Divider>
                    <Row>{this.createOtherImageDom()}</Row>
                </Form>
                <Scanner
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    initScanner={(func) => { this.setState({ initScanner: func }) }}
                    onScan={this.handleScan}
                // successCallback={}
                />
            </Modal>
        );
    }
}

const AgentEdit = Form.create()(AgentEditForm);

export default AgentEdit;